import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchGalleryBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-gallery-banners?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error) {
    dynamicFailed("Server Error");
  }
};

export const fetchGalleryData = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-gallery-images?populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error) {
    dynamicFailed("Server Error");
  }
};
